import axios from "axios";
import { Toast } from 'mand-mobile'
import router from "../router";

axios.defaults.baseURL = `${process.env.VUE_APP_API_HOST}`;
axios.defaults.headers["Content-Type"] = "multipart/form-data";


// axios.defaults.baseURL = 'https://cwapi.ttapi.in';
// axios.defaults.baseURL = 'http://127.0.0.1:8000';
// axios.defaults.baseURL = 'https://merchant.ttmanage.in';

//设置超时
axios.defaults.timeout = 60000;

axios.interceptors.request.use(
    config => {
        config.headers["Accept-Language"] = localStorage.getItem("language") || "en-us";
        config.headers["INDIATOKEN"] = localStorage.getItem("token") || "";
        config.baseURL = axios.defaults.baseURL;
        return config;
    },
    error => {
        return Promise.reject(error);
    } 
);

axios.interceptors.response.use(
    response => {
        if(response.status == 403) {
            Toast.failed("Login expired");
            localStorage.removeItem("token");
            router.push({"name": "login"});
            return;
        }
        if (response.status == 200) {
            if(response.data.code === 403) {
                Toast.failed("Login expired");
                localStorage.removeItem("token");
                router.push({"name": "login"});
            }
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    error => {
        //Toast.failed("Network Error!")
        Toast.hide();
        console.log("Network Error: ", error);
    }
);
export default {
    /**
     * @param {String} url 
     * @param {Object} data 
     * @returns Promise
     */
    post(url, data) {
        return new Promise((resolve, reject) => {
            axios({
                    method: 'post',
                    url,
                    data: data,
                })
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => {
                    reject(err)
                });
        })
    },
    get(url, data) {
        return new Promise((resolve, reject) => {
            axios({
                    method: 'get',
                    url,
                    params: data,
                })
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    siidelete(url, data) {
        return new Promise((resolve, reject) => {
            axios({
                method: 'delete',
                url,
                data: data,
            })
            .then(res => {
                resolve(res.data)
            })
            .catch(err => {
                reject(err)
            });
        })
    },

    patch(url, data) {
        return new Promise((resolve, reject) => {
            axios({
                    method: 'patch',
                    url,
                    data: data,
                })
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => {
                    reject(err)
                });
        })
    },
};



// WEBPACK FOOTER //
// ./src/request/http.js